module.exports = __webpack_public_path__ + "img/heart-outline.f324fd6c.svg";